import { computed } from 'vue'
import { useSessionManager } from './useSessionManager'

export const useAuthState = () => {
  const sessionManager = useSessionManager()

  const isLoggedIn = computed(() => sessionManager.hasActiveSession.value)

  return {
    isLoggedIn,
  }
}
